import React from 'react';
import { TextFieldGroup } from '~/admin/shared/forms/BasicForm';
import { FormattedMessage } from 'react-intl';
import { urlValidator } from '~/utils/forms';
import type { FieldApi } from 'react-form';

const handleValidateUrl = async (value: string, field: FieldApi<string>) => {
  const result = await urlValidator(value, field);
  if (result !== false) return `${result} (example.com | https://example.com)`;
  return false;
};

const WebsiteFields = () => (
  <React.Fragment>
    <TextFieldGroup
      field="websiteUrl"
      title={<FormattedMessage defaultMessage="What's your website?" />}
      placeholder="https://example.com"
      validate={handleValidateUrl}
      data-testid="website-url-input"
      data-tour-id="website-url-input"
      type="url"
    />
    <TextFieldGroup
      field="menuUrl"
      title={<FormattedMessage defaultMessage="Share a link to your menu to get started" />}
      placeholder="https://example.com"
      validate={handleValidateUrl}
      data-testid="menu-url-input"
      data-tour-id="menu-url-input"
      type="url"
    />
  </React.Fragment>
);

export default WebsiteFields;
